import Swiper from 'swiper';
import { Navigation, Autoplay, Scrollbar } from 'swiper/modules';
import { bindSlideAccessibility, slidesPerViewValue } from '../../src/js/slider-a11y.js';

function buildBreakpoints(swiperEl) {
	const columns = swiperEl.dataset.sliderColumns;
	const desktopSlidesPerView = swiperEl.dataset.sliderColumnsDesktop;
	const tabletSlidesPerView = swiperEl.dataset.sliderColumnsTablet;
	const mobileSlidesPerView = swiperEl.dataset.sliderColumnsMobile;

	let breakpoints = {
		320: {
			slidesPerView: slidesPerViewValue(mobileSlidesPerView, 1.15),
			spaceBetween: 8,
		},
		640: {
			slidesPerView: slidesPerViewValue(tabletSlidesPerView, 1.5),
			spaceBetween: 8,
		},
		1024: {
			slidesPerView: slidesPerViewValue(desktopSlidesPerView, 2.2),
			spaceBetween: 16,
		},
	};

	if ((columns && columns == '4') || desktopSlidesPerView == '4') {
		breakpoints = {
			320: {
				slidesPerView: slidesPerViewValue(mobileSlidesPerView, 1.1),
				spaceBetween: 8,
			},
			500: {
				slidesPerView: slidesPerViewValue(tabletSlidesPerView, 2),
			},
			640: {
				slidesPerView: slidesPerViewValue(tabletSlidesPerView, 3),
			},
			1024: {
				slidesPerView: slidesPerViewValue(desktopSlidesPerView, 4),
				spaceBetween: 16,
			},
		};
	}

	if ((columns && columns == '2') || desktopSlidesPerView == '2') {
		breakpoints = {
			640: {
				slidesPerView: slidesPerViewValue(desktopSlidesPerView, 2),
				spaceBetween: 16,
			},
		};
	}

	if ((columns && columns == '1') || desktopSlidesPerView == '1') {
		breakpoints = {
			640: {
				slidesPerView: slidesPerViewValue(desktopSlidesPerView, 1),
				spaceBetween: 16,
			},
		};
	}

	return breakpoints;
}

function initBentoGridSliders() {
	document.querySelectorAll('.module-bento-grid').forEach((module) => {
		const swiperEl = module.querySelector('.bento-grid__brands .swiper');
		if (!swiperEl) {
			return;
		}

		const next = module.querySelector('.bento-grid__brands .slider-nav-next');
		const prev = module.querySelector('.bento-grid__brands .slider-nav-prev');
		const scrollbarEl = swiperEl.querySelector('.swiper-scrollbar');
		const autoplayEnabled = swiperEl.dataset.sliderAutoplay;
		const autoplaySpeed = swiperEl.dataset.sliderAutoplaySpeed;
		const totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;

		if (swiperEl.swiper) {
			swiperEl.swiper.destroy(true, true);
		}

		const modules = [Navigation, Scrollbar];
		const swiperParams = {
			modules,
			slidesPerView: 1.15,
			spaceBetween: 8,
			navigation: {
				nextEl: next,
				prevEl: prev,
			},
			scrollbar: {
				el: scrollbarEl,
				draggable: true,
				hide: false,
			},
			breakpoints: buildBreakpoints(swiperEl),
		};

		if (autoplayEnabled && autoplaySpeed) {
			swiperParams.autoplay = {
				delay: autoplaySpeed * 1000,
				disableOnInteraction: true,
			};
			swiperParams.loop = true;
			modules.push(Autoplay);
		}

		if (totalSlides <= 1 && next && prev) {
			next.style.display = 'none';
			prev.style.display = 'none';
		}

		const swiper = new Swiper(swiperEl, swiperParams);
		bindSlideAccessibility(swiper);

		if (swiper.scrollbar) {
			swiper.scrollbar.updateSize();
		}

		const stage = module.querySelector('.bento-grid__brands-stage');
		if (stage) {
			const updateSliderFades = () => {
				stage.classList.toggle('is-at-beginning', swiper.isBeginning);
				stage.classList.toggle('is-at-end', swiper.isEnd);
			};

			updateSliderFades();
			swiper.on('slideChange', updateSliderFades);
			swiper.on('resize', updateSliderFades);
			swiper.on('transitionEnd', updateSliderFades);
			swiper.on('scrollbarDragMove', updateSliderFades);
		}
	});
}

document.addEventListener('DOMContentLoaded', initBentoGridSliders);
